import { Text2, skinVars, ProgressBar, Text5 } from '@telefonica/mistica';
import React, { useMemo } from 'react';
import './index.scss';
import { conversionToGB } from '../../utils/dataTransformation/unitsConversion';

export interface IExtaMobile {
    maxGigs: any;
    maxNumber: any;
    currentNumber: any;
    unit: any;
    dataBonus?: boolean;
    isBlocked: boolean;
}

export const ExtaMobile: React.FC<IExtaMobile> = ({
    maxGigs,
    maxNumber,
    currentNumber,
    unit,
    isBlocked,
}: IExtaMobile) => {
    const percent = Math.round((currentNumber * 100) / maxNumber);
    const colorTextGB = useMemo(() => {
        if (percent >= 80 && percent <= 99) {
            return skinVars.colors.warningHigh;
        } else if (percent >= 100) {
            return skinVars.colors.errorHigh;
        } else if (percent < 80) {
            return skinVars.colors.textPrimary;
        }
    }, [percent]);

    const colorProgressBar = useMemo(() => {
        if (isBlocked) {
            return skinVars.colors.neutralMedium;
        } else if (percent >= 80 && percent <= 99) {
            return skinVars.colors.warning;
        } else if (percent >= 100) {
            return skinVars.colors.errorHigh;
        } else if (percent < 80) {
            return skinVars.colors.success;
        }
    }, [percent, isBlocked]);

    return (
        <div className='mobile-consumptionDetail'>
            <div className='mobile-consumptionDetail__texts'>
                <Text5 color={colorTextGB}>{conversionToGB(unit, currentNumber, 2)}</Text5>
                <div className='mobile-consumptionDetail__texts-maxGB'>
                    <Text2 regular color={skinVars.colors.textSecondary}>
                        {maxGigs}
                    </Text2>
                </div>

                <div className='mobile-consumptionDetail__progressBar'>
                    <ProgressBar color={colorProgressBar} progressPercent={percent} />
                </div>
            </div>
        </div>
    );
};

export default ExtaMobile;
